import { render } from "./ConfirmAccountDeletion.vue?vue&type=template&id=9464d77c"
import script from "./ConfirmAccountDeletion.vue?vue&type=script&lang=js"
export * from "./ConfirmAccountDeletion.vue?vue&type=script&lang=js"

import "./ConfirmAccountDeletion.vue?vue&type=style&index=0&id=9464d77c&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__